import { render, staticRenderFns } from "./LearningCenterInfo.vue?vue&type=template&id=7dfcfaf0"
import script from "./LearningCenterInfo.vue?vue&type=script&lang=js"
export * from "./LearningCenterInfo.vue?vue&type=script&lang=js"
import style0 from "./LearningCenterInfo.vue?vue&type=style&index=0&id=7dfcfaf0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports